import { useEffect, useState } from "react"
import axios from "axios";
import { HashLoader } from "react-spinners";

export default function BalanceData(){
    const [allData,setAllData] = useState();
    const [loading,setloading] = useState(false);

    const rootUrl = "http://localhost:3000";
    const localrootUrl = "https://ahkserver.onrender.com";

    function calSum(data){
        if(data){
            var sum = 0;
        for(var i=0;i<data.length;i++){
          sum += data[i].received;
        }
        return sum;
        }else{
            return 0;
        }
      }
      function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
        }

    useEffect(()=>{
        const fetchData = async ()=>{
            try{
            setloading(true);
            const dataposter = await axios.get(`${localrootUrl}/getAllmrnumber`,{withCredentials:true});
            const response = dataposter.data;
            if(response){
                setAllData(response);
                setloading(false);
            }
            await sleep(500);
            setloading(false);
            }catch(error){
                await sleep(500);
                setloading(false);
                console.log(error);
            }
        }
        fetchData();
    },[])


    return <div key={allData} className="colWise">
        {allData?allData.map((val)=>{
            return <div className="rowWise">
                <p className="datatxt">Name: {val.name}</p>
                <p className="datatxt"> Mobile Number: {val.mobileNumber}</p>
                <p className="datatxt">Email: {val.email}</p>
                <p className="datatxt">Amount Received: {val.received}</p>
            </div>
        }):loading?<HashLoader size={100} loading={loading}/>:<h1>No Data to Show</h1>}
        <h1>{allData?"Total Earned: Rs "+calSum(allData):null}</h1>
    </div>
}